import { createSlice } from "@reduxjs/toolkit";

const getStoredAuth = () => {
  const token = localStorage.getItem("jwt_token");

  return {
    token: token || null,
    isLoggedIn: !!token,
  };
};

const initialState = {
  ...getStoredAuth(),
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginUser: (state, { payload }) => {
      const { access_token, user_details, org_type } = payload;

      // ✅ update redux
      state.token = access_token;
      state.currentUser = user_details;
      state.isLoggedIn = true;

      // ✅ sync localStorage
      localStorage.setItem("jwt_token", access_token);
      localStorage.setItem("is_admin", user_details.is_admin);
      localStorage.setItem("user_id", user_details.id);
      localStorage.setItem("type", org_type);
    },

    logoutUser: (state) => {
      // ✅ reset redux
      state.token = null;
      state.currentUser = null;
      state.isLoggedIn = false;

      // ✅ clear storage
      localStorage.clear();
    },

    loadUser: (state) => {
      const stored = getStoredAuth();
      state.token = stored.token;
      state.isLoggedIn = stored.isLoggedIn;
    },
  },
});

export const { loginUser, logoutUser, loadUser } = authSlice.actions;

export default authSlice.reducer;